import React, { useState, useEffect } from 'react';
import axios from 'axios';
import authHeader from '../services/AuthHeader';
import { Grid, Row, Col, Panel, PageHeader, Image, Glyphicon } from 'react-bootstrap';

const ViewAllCandidates = () => {
  const [ballots, setBallots] = useState({});
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch all candidates
    axios
      .get(`${process.env.REACT_APP_API_BASE}candidate/`, { headers: authHeader() })
      .then((res) => {
        const candidates = res.data;
        // Group candidates by ballotId
        const grouped = candidates.reduce((acc, candidate) => {
          const ballotId = candidate.ballotId || 'Unassigned Ballot';
          if (!acc[ballotId]) {
            acc[ballotId] = [];
          }
          acc[ballotId].push(candidate);
          return acc;
        }, {});

        setBallots(grouped);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching candidates:', error);
        setLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <Grid>
        <Row>
          <Col xs={12} md={12} className="text-center" style={{ paddingTop: '50px' }}>
            {/* Simple Loading Indicator */}
            <Glyphicon glyph="refresh" className="glyphicon-refresh-animate" style={{ fontSize: '24px' }} />
            <span style={{ marginLeft: '10px' }}>Loading...</span>
          </Col>
        </Row>
      </Grid>
    );
  }

  return (
    <Grid>
      <Row>
        <Col xs={12}>
          <PageHeader>Candidates by Ballot</PageHeader>
        </Col>
      </Row>
      {Object.keys(ballots).map((ballotId) => (
        <Row key={ballotId} className="mb-5">
          <Col xs={12}>
            <h2 className='h3'>Ballot ID: {ballotId}</h2>
          </Col>
          {ballots[ballotId].map((candidate) => (
            <Col key={candidate.candidateId} xs={12} sm={6} md={4} style={{ marginBottom: '20px' }}>
              <Panel>
                <Image
                  src={
                    candidate.imageFileName
                      ? `${process.env.REACT_APP_API_BASE}imageview/${candidate.candidateId}_${candidate.imageFileName}`
                      : '/no-picture-available-icon.jpg'
                  }
                  alt={`${candidate.firstName} ${candidate.lastName}`}
                  responsive
                  style={{ width: '100%', height: '200px', objectFit: 'cover', marginBottom: '15px' }}
                />
                <Panel.Heading>
                  <Panel.Title componentClass="h3">
                    {candidate.firstName} {candidate.lastName}
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <p>
                    <strong>Party Affiliation:</strong> {candidate.party || 'Independent'}
                  </p>
                  <p>
                    <strong>Statement:</strong>
                    <br />
                    {candidate.candidateStatement || 'Not Available'}
                  </p>
                </Panel.Body>
              </Panel>
            </Col>
          ))}
        </Row>
      ))}
    </Grid>
  );
};

// Add CSS for spinner animation
const spinnerStyle = `
  .glyphicon-refresh-animate {
    -animation: spin 1s infinite linear;
    -webkit-animation: spin 1s infinite linear;
  }

  @-webkit-keyframes spin {
    from { -webkit-transform: rotate(0deg);}
    to { -webkit-transform: rotate(360deg);}
  }

  @keyframes spin {
    from { transform: rotate(0deg);}
    to { transform: rotate(360deg);}
  }
`;

// Inject the spinner CSS into the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = spinnerStyle;
document.head.appendChild(styleSheet);

export default ViewAllCandidates;
